import { translate } from '~l10n/client';

let Backbone = require('backbone');
let _ = require('underscore');
let Quiz = require('quiz-model');
let popup = require('../../../shared/components/popup/PopupController');
let request = require('../../../../shared/Request');

let mockStandard = null;

let EditQuizModel = Backbone.Model.extend({
  currentUrl: '',
  saveAndExitClicked: false,
  questionInEditMode: false,

  reset: function () {
    this.saveAndExitClicked = false;
  },

  setUpStandard: function (quizData, callback) {
    this.quiz = new Quiz(quizData);
    if (this.quiz.standard) {
      this.quiz.standard.standardsObject = _.clone(this.blueprint);
      this.quiz.standard.dirty = false;
      this.quiz.standard.complete = true;
    }

    callback();
  },

  blueprint: {
    subject: [
      { id: 1, name: 'Math' },
      { id: 2, name: 'Science' },
      { id: 3, name: 'Language Arts' },
      { id: 4, name: 'Social Studies' },
      { id: 5, name: 'Other Subjects' },
    ],
    core: null,
    class: null,
    standard: null,
  },

  standardsObject: {},

  standardURL: '//app.masteryconnect.com/api/query_types/{0}?TOKEN=', // The url-encoded token to be sent when requesting standards.

  token:
    'q7%2Ak%2F%40u-%5DQsY%2C%60%3FR+%2CF1P-yNq%3C9k%28%7BW%7CF89oh%3E%5ETP.Yft%2C%261OtaUY+%29_Fft%7Buq3zD%7CjdY%5B%3AVR%26%7C%3Ak%3FwGvXng.Z%3B%2Be%2A%5D2-_%2BU-+BQ%2AYM%7BTUC%2FEKPy%2A2%7B%2F4Rdcau%216vW%5B%40',

  // The queries that will be made when an option is chosen from the dropdowns:
  queries: {
    initial: [
      'subjects',
      'query Subjects  { subjects                                  { id name } }',
    ],
    subject: [
      'pathways',
      'query Cores     { pathways(subject_id: {0})                 { id name available state { id name code} } }',
    ],
    core: [
      'class_objective_pathways',
      'query Classes   { class_objective_pathway(pathway_id: {0})  { id class_objective { id name } }}',
    ],
    class: [
      'class_objectives',
      'query Standards { class_objective(id: {0})                  { id name objectives { id name short_description objective_id sub_objectives } } }',
    ],
  },

  addNewStandard: function () {
    this.quiz.standard = {
      dirty: true,
      complete: false,
      standardsObject: _.clone(this.blueprint),
    };
  },

  setStandards: function (changed, standard) {
    let quizStandard = this.quiz.standard;

    if (changed === 'subject') {
      quizStandard['core'] = null;
      quizStandard['class'] = null;
      quizStandard['standard'] = null;
      quizStandard.standardsObject['core'] = [];
      quizStandard.standardsObject['class'] = null;
      quizStandard.standardsObject['standard'] = null;
    } else if (changed === 'core') {
      quizStandard['class'] = null;
      quizStandard['standard'] = null;
      quizStandard.standardsObject['class'] = [];
      quizStandard.standardsObject['standard'] = null;
    } else if (changed === 'class') {
      quizStandard['standard'] = null;
      quizStandard.standardsObject['standard'] = [];
    } else if (changed === 'standard') {
      _.each(quizStandard.standardsObject['standard'], (std) => {
        if (String(std.id) === standard) {
          std.name = String(std.name).toUpperCase();
          quizStandard['standard'] = std;
        }
      });
      if (!quizStandard.complete) {
        this.checkStandard();
      } else {
        this.trigger('render');
      }
      return;
    } else if (changed === 'save') {
      if (this.checkStandard()) {
        this.quiz.set('dirty', true);
      } else {
        popup.render({
          title: translate('Incomplete Standard'),
          message: translate('The quiz standard is not complete.'),
        });
      }

      return;
    } else {
      console.warn('Strange changed event name received:', changed, standard);
      return;
    }

    quizStandard[changed] = parseInt(standard);

    this.getStandardData(changed, standard);
  },
  // used for editing
  getStandardList: function (callback) {
    let standard = this.quiz.standard;

    if (_.isEmpty(standard.standardsObject['core'])) {
      this.getStandardData('subject', standard['subject']);
    }

    if (_.isEmpty(standard.standardsObject['class'])) {
      this.getStandardData('core', standard['core']);
    }

    if (_.isEmpty(standard.standardsObject['standard'])) {
      this.getStandardData('class', standard['class']);
    }

    callback();
  },

  getStandardData: function (changed, standard) {
    let that = this;
    let quizStandard = this.quiz.standard;

    let successFunction = function (data) {
      if (_.isEmpty(data['data'])) {
        that.trigger('error:emptyApiResponse', changed);
        return;
      }

      if (changed === 'initial') {
        if (_.isEmpty(data['data']['subjects'])) {
          that.trigger('error:emptyApiResponse', changed);
          return;
        }

        quizStandard['standardsObject']['subject'] = data['data']['subjects'];
      } else if (changed === 'subject') {
        if (_.isEmpty(data['data']['pathways'])) {
          that.trigger('error:emptyApiResponse', changed);
          return;
        }

        // Filter out the cores that shouldn't be in the list.
        quizStandard['standardsObject']['core'] = _.filter(
          data['data']['pathways'],
          function (a) {
            return a.available;
          }
        );

        // Group the cores by state.
        quizStandard['standardsObject']['core'] = _.groupBy(
          quizStandard['standardsObject']['core'],
          function (a) {
            return a.state.name;
          }
        );

        // Sort the cores in each state. The states are sorted in the standards view.
        _.each(quizStandard['standardsObject']['core'], (coreList, index) => {
          quizStandard['standardsObject']['core'][index] = _.sortBy(
            coreList,
            'name'
          );
        });
      } else if (changed === 'core') {
        if (_.isEmpty(data['data']['class_objective_pathway'])) {
          that.trigger('error:emptyApiResponse', changed);
          return;
        }

        quizStandard['standardsObject']['class'] =
          data['data']['class_objective_pathway']; // The list of classrooms.
      } else if (changed === 'class') {
        if (_.isEmpty(data['data']['class_objective']['objectives'])) {
          that.trigger('error:emptyApiResponse', changed);
          return;
        }

        quizStandard['standardsObject']['standard'] =
          data['data']['class_objective']['objectives'];

        // Some standards have sub objectives that are being sent as a JSON string.
        _.each(quizStandard['standardsObject']['standard'], (standard, key) => {
          // Override the sub_objectives string with the parsed object.
          quizStandard['standardsObject']['standard'][key]['sub_objectives'] =
            [];
        });
      }
      that.trigger('render');
    };

    if (window.location.hostname.toLowerCase() === 'b.socrative.localhost') {
      if (!mockStandard) {
        require.ensure(['MockStandard'], (require) => {
          mockStandard = require('MockStandard');
          successFunction(mockStandard[changed]);
        });
      } else {
        setTimeout(() => {
          // Simulate the standard being loaded.
          successFunction(mockStandard[changed]);
        }, 375);
      }
    } else {
      let queryOptions = this.queries[changed];
      let query = queryOptions[1].format(standard); // Get the query from our dictionary.
      request.post({
        url: this.standardURL.format(queryOptions[0]) + this.token,
        data: query,
        success: successFunction,
        error: () => {
          quizStandard.dirty = false;
          quizStandard.complete = false;
          quizStandard.noAccess = true;

          that.trigger('render');
        },
      });
    }
    that.trigger('render');
  },

  checkStandard: function () {
    let quizStandard = this.quiz.standard;

    if (quizStandard) {
      if (
        quizStandard['subject'] &&
        quizStandard['core'] &&
        quizStandard['class'] &&
        quizStandard['standard']
      ) {
        quizStandard.complete = true;
        quizStandard.dirty = false;

        this.trigger('render');

        return true;
      } else {
        return quizStandard.noAccess;
      }
    }

    return true;
  },
});

module.exports = new EditQuizModel();
